import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestPending: boolean;
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  cancelJob(request: Boundaries["cancelJob"]["request"]): void;
}

function useCancelJob(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isCancelJobRequestPending),
    isRequestSuccess: useSelector(selector.isCancelJobRequestSuccess),
    isRequestFailure: useSelector(selector.isCancelJobRequestFailure),
    cancelJob: core.cancelJob,
  };
}

export { useCancelJob };
